<template>
  <v-card>
    <v-card-title class="headline"><span v-t="'ordersListContainer.usersWithoutOrder'" /></v-card-title>
    <v-data-table
      :rows-per-page-text="$t('dataTables.rowsPerPage')"
      :no-data-text="$t('dataTables.noData')"
      :loading="loading > 0"
      :headers="headers"
      :items="usersWithoutRequests"
      class="elevation-1"
      :rows-per-page-items="rowsPerPage"
    >
      <template slot="items" slot-scope="props">
        <td style="min-width: 190px;">{{ props.item.displayName }}</td>
      </template>
      <template slot="pageText" slot-scope="props">
        {{ $t('dataTables.pagingRow', { start: props.pageStart, stop: props.pageStop, length: props.itemsLength }) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import gql from 'graphql-tag';
import ErrorHandler from '@/services/ErrorHandler';
import NotificationService from '@/services/NotificationService';

export default {
  name: 'UsersWithoutRequestsModal',
  props: {
    date: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: 0,
    usersWithoutRequests: [],
  }),
  computed: {
    headers() {
      const defaultHeaders = [{
        text: this.$t('ordersListContainer.name'), align: 'left', sortable: true, value: 'displayName',
      }];

      return defaultHeaders;
    },
    rowsPerPage() {
      return [10, 20, 50, { text: this.$t('dataTables.all'), value: -1 }];
    },
  },
  apollo: {
    $loadingKey: 'loading',
    usersWithoutRequests: {
      fetchPolicy: 'network-only',
      query: gql`query UsersWithoutRequestsQuery($date: TimelessDate!) {
        usersWithoutRequests(date: $date) {
          id
          displayName
        }
      }`,
      variables() {
        return {
          date: this.date,
        };
      },
      skip() {
        return !this.date;
      },
      error(error) {
        this.usersWithoutRequests = null;
        ErrorHandler.handleApolloError(error);
      },
      result(r) {
        if (!r.loading) {
          NotificationService.clearNetworkNotification();
        }
      },
    },
  },
};
</script>
